import { ZodObject, ZodRawShape, z } from 'zod/v4';

// Generic group schema that can be extended
export const createBaseGroupSchema = <T extends ZodRawShape>(additionalFields: ZodObject<T>) => {
    return z
        .object({
            id: z.string().optional(),
            name: z.string(),
        })
        .extend(additionalFields.shape);
};

// Type helper for group inference
export type InferGroupType<T extends ZodRawShape> = z.infer<ReturnType<typeof createBaseGroupSchema<T>>>;
